module.exports = __webpack_public_path__ + "fonts/attuned-logo.svg";